(() => {
  const pickerFromEvent = (event) => {
    const eventPicker = event.target?.closest?.('[data-inpost-picker]');
    return eventPicker || document.querySelector('[data-inpost-dialog][open]')?.closest('[data-inpost-picker]');
  };

  const closePicker = (picker) => {
    const dialog = picker?.querySelector('[data-inpost-dialog]');
    if (dialog?.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-inpost-open]');
    if (openButton) {
      const picker = openButton.closest('[data-inpost-picker]');
      const dialog = picker?.querySelector('[data-inpost-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-inpost-close]');
    if (closeButton) {
      closePicker(closeButton.closest('[data-inpost-picker]'));
      return;
    }

    const dialog = event.target.closest('[data-inpost-dialog]');
    if (dialog && event.target === dialog) closePicker(dialog.closest('[data-inpost-picker]'));
  });

  document.addEventListener('inpost-point-selected', async (event) => {
    const point = event.details || event.detail || {};
    const picker = pickerFromEvent(event);
    if (!point.name || !picker) return;

    const address = point.address || {};
    const addressDetails = point.address_details || {};
    const fallbackAddress = [
      addressDetails.street && addressDetails.building_number
        ? `${addressDetails.street} ${addressDetails.building_number}`
        : addressDetails.street,
      addressDetails.post_code,
      addressDetails.city
    ].filter(Boolean).filter((value, index, values) => values.indexOf(value) === index).join(', ');
    const addressText = [address.line1, address.line2].filter(Boolean).join(', ') || fallbackAddress;

    const status = picker.querySelector('[data-inpost-status]');
    const openButton = picker.querySelector('[data-inpost-open]');
    const actionText = picker.querySelector('[data-inpost-action]');
    const selection = picker.querySelector('[data-inpost-selection]');
    const pointNode = picker.querySelector('[data-inpost-point]');
    const addressNode = picker.querySelector('[data-inpost-address]');

    status.textContent = 'Zapisuję wybrany punkt…';
    openButton.disabled = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Paczkomat InPost': point.name,
            'Adres Paczkomatu InPost': addressText
          }
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      pointNode.textContent = point.name;
      addressNode.textContent = addressText;
      selection.classList.remove('hidden');
      openButton.setAttribute('aria-pressed', 'true');
      actionText.textContent = 'Kliknij, aby zmienić punkt';
      status.textContent = 'Paczkomat został zapisany do zamówienia.';
      closePicker(picker);
    } catch (error) {
      status.textContent = 'Nie udało się zapisać punktu. Spróbuj ponownie.';
    } finally {
      openButton.disabled = false;
    }
  });
})();
